<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <img src="img/avatars/user.png"
           class="img-avatar"
           alt="admin@bootstrapmaster.com" />
    </template>\
    <template slot="dropdown">
      <b-dropdown-header tag="div" class="text-center"><strong>{{ $auth.user().nombre }} {{ $auth.user().nm_apellido }}</strong></b-dropdown-header>
      <b-dropdown-item href="#/pages/Change"><i class="fa fa-shield" />{{ $t('Password') }}</b-dropdown-item>
      <b-dropdown-item @click="logout"><i class="fa fa-lock" />{{ $t('Logout') }}</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
  import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
  export default {
    name: 'DefaultHeaderDropdownAccnt',
    components: {
      AppHeaderDropdown
    },
    data: () => {
      return { itemsCount: 42 }
    },
    methods: {
      logout: function () {
        this.actionLogout();
      }
    },
    mounted() {
    }
  }
</script>
